import styled from '@emotion/styled'
import { useRouter } from 'next/router'

import { ButtonRow, StyledButton, StyledLink } from './sharedStyles'
import InfoBanner from 'components/InfoBanner'

const StyledInfoBanner = styled(InfoBanner)`
	margin-top: 0;
`

type Props = {
	displayType: 'account' | 'container'
}

const EmptyDataInfoBanner = ({ displayType }: Props) => {
	const router = useRouter()

	const handleRefresh = () => {
		router.reload()
	}

	const handleCancel = () => {
		router.push('/configurator/code-snippet')
	}

	return (
		<>
			<StyledInfoBanner title={`No available ${displayType === 'account' ? 'account' : 'containers for this account'}`}>
				To install OpenWidget, create a new {`${displayType === 'account' ? 'account' : 'container'}`} in the{' '}
				<StyledLink href="https://tagmanager.google.com/#/home" target="_blank" rel="noreferrer">
					Google Tag Manager dashboard
				</StyledLink>
				. Afterward, return to OpenWidget and click the &quot;Refresh&quot; button to continue the setup.
			</StyledInfoBanner>
			<ButtonRow>
				<StyledButton kind="secondary" onClick={handleCancel}>
					Cancel
				</StyledButton>
				<StyledButton kind="primary" onClick={handleRefresh}>
					Refresh
				</StyledButton>
			</ButtonRow>
		</>
	)
}

export default EmptyDataInfoBanner
